import DataMutations                           from '../graphql/Mutations';
import DataQueries                             from '../graphql/Queries';
import DocumentDialogModel, { DocumentSchema } from './DocumentDialogModel';

export default new DocumentDialogModel(
  'Hours Earned Type',
  (ids: string[]) => DataQueries.getDocumentByIds(DocumentSchema, ids),
  DataMutations.insertDocuments.bind(undefined, 'hoursEarnedType'),
  DataMutations.updateDocuments.bind(undefined, 'hoursEarnedType'),
  DataMutations.deleteDocuments,
  'documents'
);
